<div>
  <div class="panels">

    <div class="left-panel col-4">
      <div class="d-flex flex-column align-items-start mb-5" style="gap: 20px;">
        <a data-testid="auto-app-create-campaign-zero-a-1" class="text-webbtree-green" [ngClass]="{ 'disabled': isInEditMode?.editMode }" style="cursor: pointer;" (click)="!isInEditMode?.editMode && redirectToCreateCampaign()">
          <i class="fas fa-arrow-left" style="margin-top: 12px;"></i>
          Back
        </a>
        <div style="font-size: 14px; color:#484b59;">
          {{campaign_details.campaign_name}}
        </div>
      </div>
      <div *ngIf="currentActiveCampaignCount > 0 && campaign_details?.status === 3" class="active-campaign-warning">
        <i class="fas fa-exclamation-triangle mr-2"></i>
        You have <strong>{{ currentActiveCampaignCount }}</strong> active campaign(s) running. Starting this campaign will place it in <strong>Paused</strong> state. To run it, pause an active campaign from the <a data-testid="auto-app-create-campaign-zero-a-2" [routerLink]="listingPath" style="color:#9c6b00; text-decoration: underline;">listing screen</a>.
      </div>
@if (isLoaded && campaign_details) {
  <app-progress-panel
    (selected)="setEditPanelData($event)"
    (addStep)="addNewStage($event)"
    [isInEditMode]="isInEditMode"
    [canSwitch]="canEditStage"
    [stages]="availableStages"
    [stage]="activatedStage"
    [campaign_details]="campaign_details"
    [currentActiveCampaignCount]="currentActiveCampaignCount"
    [readOnly]="!canEditCampaign"
    (changeEditMode)="setIsEditMode($event)">
  </app-progress-panel>
}
 </div>
    @if(isLoaded && campaign_details) {
    <div class="right-panel col-8" style="position: relative;">
      <app-edit-panel  [readOnly]="!canEditCampaign" [prevStageId]="prevStageId" [availableStages]="availableStages" (deleteStep)="addNewStage($event)" (isEditMode)="setIsEditMode($event)" [isInEditMode]="isInEditMode" (updatedStage)="updateStageValue($event)" [stages]="availableStages" [stage]="activatedStage" [campaign_details] = "campaign_details" (updatedCampaign)="updateCampaignDetails($event)"></app-edit-panel>
    </div>
    }

  </div>

</div>
<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>
